type Listener = () => void;

const listeners = new Set<Listener>();

let connected = true;

const emit = () => {
  for (const listener of listeners) {
    listener();
  }
};

export const connectionStatus = {
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  getStatus(): boolean {
    return connected;
  },

  setConnected() {
    if (!connected) {
      connected = true;
      emit();
    }
  },

  setDisconnected() {
    if (connected) {
      connected = false;
      emit();
    }
  },
};
